import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';

import {
  addDisplayedActions,
  ensureDisplayedAction,
  removeEligibleAnnouncement,
} from '+/actions/';
import useCurrentUser from '+/utils/hooks/useCurrentUser';
import useDisplayedActions from '+/utils/hooks/useDisplayedActions';
import useEligibleActions from '+/utils/hooks/useEligibleActions';
import useEligibleAnnouncements from '+/utils/hooks/useEligibleAnnouncements';

import { MainActionFeed } from './MainActionFeed.component';

const mapDispatchToProps = dispatch => ({
  addDisplayedActions: () => {
    dispatch(addDisplayedActions());
  },
  ensureDisplayedAction: (actionType, actionId) => {
    dispatch(ensureDisplayedAction({ actionType, actionId }));
  },
  removeEligibleAnnouncement: announcementId => {
    dispatch(removeEligibleAnnouncement(announcementId));
  },
});

export default connect(
  null,
  mapDispatchToProps,
)(props => {
  const currentUser = useCurrentUser();
  const eligibleActions = useEligibleActions();
  const eligibleAnnouncements = useEligibleAnnouncements();
  const displayedActions = useDisplayedActions();
  const { actionType, actionId } = useParams();
  const { ensureDisplayedAction: ensureDisplayed } = props;

  // A deep-linked action must be in the feed for its card to open.
  useEffect(() => {
    if (actionType && actionId && !eligibleActions.isLoading()) {
      ensureDisplayed(actionType, actionId);
    }
  }, [actionType, actionId, eligibleActions, ensureDisplayed]);

  return (
    <MainActionFeed
      {...props}
      currentUser={currentUser}
      displayedActions={displayedActions}
      eligibleActions={eligibleActions}
      eligibleAnnouncements={eligibleAnnouncements}
    />
  );
});
